import { render, staticRenderFns } from "./IBSInboundFor3rdParty.vue?vue&type=template&id=0830598b&scoped=true"
import script from "./IBSInboundFor3rdParty.vue?vue&type=script&lang=js"
export * from "./IBSInboundFor3rdParty.vue?vue&type=script&lang=js"
import style0 from "./IBSInboundFor3rdParty.vue?vue&type=style&index=0&id=0830598b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830598b",
  null
  
)

export default component.exports